interface Props {
  eyebrow: string;
  title: string;
  desc?: string;
  center?: boolean;
}

export default function SectionHeading({ eyebrow, title, desc, center = false }: Props) {
  return (
    <div className={`mb-8 md:mb-10 ${center ? 'text-center' : ''}`}>
      <div
        className={`mb-3 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800 ${
          center ? 'mx-auto' : ''
        }`}
      >
        <i className="ri-flashlight-line text-sm leading-none" />
        <span className="whitespace-nowrap font-label">{eyebrow}</span>
      </div>
      <h2 className="font-display text-2xl text-foreground-950 md:text-4xl">
        <span className="text-primary-600">{title.slice(0, 2)}</span>
        {title.slice(2)}
      </h2>
      {desc ? (
        <p className={`mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base ${center ? 'mx-auto' : ''}`}>
          {desc}
        </p>
      ) : null}
    </div>
  );
}